import { AbstractPmsApiService } from "./abstract.service";
import { City } from "../models";

/**
 * @class CityPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<City>}
 */
export class CityPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/country/:countryId/city(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param {...*} params
     * @returns {City}
     * @protected
     */
    newModel(attributes, ...params) {

        return new City(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Country=} country
     * @returns {Promise.<PaginationCollection<City>>}
     */
    get (params = {}, country = null) {

        const url = this.url({countryId: country ? country.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {City} city
     * @param {Country} country
     * @returns {Promise.<City>}
     */
    create(city, country) {

        const url = this.url({countryId: country.id});

        return this.http
                   .post(url, city.toObjectExcept('country'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {City} city
     * @returns {Promise.<City>}
     */
    update(city) {

        const url = this.url({
                                 countryId: city.country.id,
                                 id: city.id
                             });

        return this.http
                   .put(url, city.toObjectExcept('country'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {City} city
     * @returns {Promise.<boolean>}
     */
    delete(city) {

        const url = this.url({
                                 countryId: city.country.id,
                                 id: city.id
                             });

        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }

    show(city) {

        const url = this.url({
            countryId: city.country.id,
            id: city.id
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    canDelete(city) {

        const url = this.url({
            countryId: city.country.id,
            id: city.id
        }) + '/can-delete';

        return this.http
            .get(url, {
                headers: this.authHeaders,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/city.service.js